export default [
    { id: 0, name: 'Any Reason' },
    { id: 1, name: 'Reason for voiding' },
    { id: 2, name: 'Reason for cash in' },
    { id: 3, name: 'Reason for cash out' },
];



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/setting/presetreason/types.js